function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">

          {/* Left Column — Company Title & Description (35%) */}
          <div className="w-full lg:w-[35%] flex flex-col justify-center">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-semibold text-foreground-950 leading-[1.08] tracking-tight">
              (Appscott LLC)
            </h1>
            <p className="mt-8 md:mt-10 text-base md:text-lg text-foreground-600 leading-relaxed max-w-md font-light">
              A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
            </p>
          </div>

          {/* Middle Column — Abstract Geometric Image (35%) */}
          <div className="w-full lg:w-[35%] flex items-center">
            <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20of%20intersecting%20grid%20lines%20and%20architectural%20wireframe%20shapes%20in%20warm%20teal%20and%20soft%20amber%20tones%20on%20an%20off%20white%20background%2C%20minimal%20engineering%20aesthetic%20with%20clean%20precise%20lines%2C%20subtle%20depth%20through%20layered%20transparent%20planes%2C%20modern%20technical%20diagram%20style%20without%20any%20text%20or%20human%20elements%2C%20soft%20diffused%20lighting&width=700&height=525&seq=hero-geometric-01&orientation=landscape"
                alt="Abstract geometric engineering composition"
                className="w-full h-full object-cover object-top"
                title="Engineering architecture aesthetic"
              />
            </div>
          </div>

          {/* Right Column — Image Grid (30%) */}
          <div className="w-full lg:w-[30%] flex flex-col gap-5">
            <div className="flex items-start justify-between">
              <p className="font-heading text-lg md:text-xl font-medium text-foreground-800 leading-snug">
                Engineering<br />Precision
              </p>
              <span className="w-8 h-8 flex items-center justify-center text-accent-500/60 mt-1">
                <i className="ri-arrow-right-up-line text-xl"></i>
              </span>
            </div>
            <div className="grid grid-cols-2 gap-3 flex-1">
              <div className="col-span-2 relative aspect-square rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20architectural%20wireframe%20composition%20with%20overlapping%20translucent%20geometric%20planes%20in%20warm%20earth%20tones%20of%20terracotta%20and%20sand%20on%20a%20cream%20background%2C%20engineering%20blueprint%20aesthetic%20with%20delicate%20intersecting%20grid%20patterns%2C%20minimal%20clean%20design%20without%20any%20text%20or%20human%20figures%2C%20soft%20ambient%20light%20creating%20subtle%20tonal%20variations&width=400&height=400&seq=hero-grid-02&orientation=squarish"
                  alt="Abstract architectural wireframe pattern"
                  className="w-full h-full object-cover object-top"
                  title="Engineering blueprint aesthetic"
                />
                <div className="absolute bottom-3 left-3 bg-background-50/90 backdrop-blur-sm rounded-lg px-3 py-1.5">
                  <span className="text-xs font-medium text-foreground-700 tracking-wide">iOS Platform</span>
                </div>
              </div>
              <div className="aspect-square rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20minimal%20abstract%20composition%20of%20concentric%20geometric%20rings%20and%20radial%20symmetry%20patterns%20in%20muted%20olive%20and%20ochre%20tones%2C%20soft%20paper%20textured%20off%20white%20background%2C%20precise%20technical%20illustration%20aesthetic%20reminiscent%20of%20engineering%20schematics%2C%20no%20text%20or%20human%20elements%2C%20gentle%20natural%20lighting&width=300&height=300&seq=hero-grid-03&orientation=squarish"
                  alt="Abstract concentric geometric pattern"
                  className="w-full h-full object-cover object-top"
                  title="Engineering schematic aesthetic"
                />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20tessellated%20geometric%20pattern%20of%20interconnected%20hexagonal%20modules%20in%20warm%20graphite%20and%20sandstone%20tones%2C%20structured%20engineering%20inspired%20layout%20on%20a%20light%20cream%20background%2C%20precise%20mathematical%20aesthetic%20without%20any%20text%20or%20figures%2C%20soft%20diffuse%20illumination%20creating%20subtle%20depth&width=300&height=300&seq=hero-grid-04&orientation=squarish"
                  alt="Abstract tessellated hexagonal pattern"
                  className="w-full h-full object-cover object-top"
                  title="Mathematical precision aesthetic"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HeroSection;